type WidgetInstance = { open: (view?: string) => void; close: () => void; destroy: () => void }
declare global {
  interface Window {
    DihawWidget?: { mount: (config: { url: string; onClose: () => void }) => WidgetInstance }
  }
}

const defaultOrigin = import.meta.env.DEV ? 'http://127.0.0.1:4900' : 'https://dihaw.dev'
export const widgetUrl = import.meta.env.VITE_DIHAW_WIDGET_URL || `${defaultOrigin}/widget`
const loaderUrl = import.meta.env.VITE_DIHAW_WIDGET_LOADER_URL || `${defaultOrigin}/widget.js`
let loading: Promise<WidgetInstance> | undefined

export function loadDihawWidget(): Promise<WidgetInstance> {
  if (loading) return loading
  loading = new Promise<WidgetInstance>((resolve, reject) => {
    const widget = new URL(widgetUrl), loader = new URL(loaderUrl)
    if (widget.origin !== loader.origin || widget.pathname !== '/widget' || loader.pathname !== '/widget.js' ||
      widget.username || widget.password || loader.username || loader.password || widget.search || widget.hash || loader.search || loader.hash ||
      !(widget.protocol === 'https:' || (widget.protocol === 'http:' && ['localhost', '127.0.0.1'].includes(widget.hostname)))) {
      reject(new Error('Invalid Dihaw configuration'))
      return
    }
    const mount = () => {
      try {
        if (!window.DihawWidget) throw new Error('Dihaw loader unavailable')
        resolve(window.DihawWidget.mount({ url: widgetUrl, onClose: () => window.dispatchEvent(new Event('dihaw-widget-close')) }))
      } catch (error) { reject(error) }
    }
    if (window.DihawWidget) { mount(); return }
    const script = document.createElement('script')
    script.src = loader.href
    script.async = true
    script.dataset.auto = 'false'
    const timer = window.setTimeout(() => { script.remove(); reject(new Error('Dihaw loader timed out')) }, 15000)
    script.onload = () => { clearTimeout(timer); mount() }
    script.onerror = () => { clearTimeout(timer); script.remove(); reject(new Error('Dihaw loader unavailable')) }
    document.head.append(script)
  }).catch((error: unknown) => { loading = undefined; throw error })
  return loading
}

export async function openDihawWidget() {
  const widget = await loadDihawWidget()
  widget.open('upload')
}
